/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const GetEventVolumePayloadKinds = {
  Log: "log",
  Span: "span",
} as const;
export type GetEventVolumePayloadKinds = ClosedEnum<
  typeof GetEventVolumePayloadKinds
>;

/**
 * Payload for the org-scoped event volume timeseries
 */
export type GetEventVolumePayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Optional signal kind filter. Empty means both logs and spans.
   */
  kinds?: Array<GetEventVolumePayloadKinds> | undefined;
  /**
   * Optional event/span name filter. Values are ORed.
   */
  names?: Array<string> | undefined;
  /**
   * Optional case-insensitive substring match over event body and name
   */
  search?: string | undefined;
  /**
   * Optional source filter (canonicalized service names). Values are ORed.
   */
  sources?: Array<string> | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export const GetEventVolumePayloadKinds$outboundSchema: z.ZodMiniEnum<
  typeof GetEventVolumePayloadKinds
> = z.enum(GetEventVolumePayloadKinds);

/** @internal */
export type GetEventVolumePayload$Outbound = {
  from: string;
  kinds?: Array<string> | undefined;
  names?: Array<string> | undefined;
  search?: string | undefined;
  sources?: Array<string> | undefined;
  to: string;
};

/** @internal */
export const GetEventVolumePayload$outboundSchema: z.ZodMiniType<
  GetEventVolumePayload$Outbound,
  GetEventVolumePayload
> = z.object({
  from: z.pipe(z.date(), z.transform(v => v.toISOString())),
  kinds: z.optional(z.array(GetEventVolumePayloadKinds$outboundSchema)),
  names: z.optional(z.array(z.string())),
  search: z.optional(z.string()),
  sources: z.optional(z.array(z.string())),
  to: z.pipe(z.date(), z.transform(v => v.toISOString())),
});

export function getEventVolumePayloadToJSON(
  getEventVolumePayload: GetEventVolumePayload,
): string {
  return JSON.stringify(
    GetEventVolumePayload$outboundSchema.parse(getEventVolumePayload),
  );
}
